import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement,
  WSFlexBox,
  WSPanel
} from "@wingspanhq/fe-component-library";
import {
  IPayeeEngagementResponse,
  IPayeeResponse
} from "@wingspanhq/payments/dist/interfaces";
import { FieldView } from "../../../shared/components/FieldView/FieldView";
import React from "react";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";

export interface RestorationNotAllowedModalProps {
  payee: IPayeeResponse;
  engagement: IPayeeEngagementResponse;
  onClose: () => void;
}

export const RestorationNotAllowedModal: React.FC<
  RestorationNotAllowedModalProps
> = ({ payee, engagement, onClose }) => {
  const payeeNames = wsName({
    user: payee.user!,
    member: payee.member
  });

  return (
    <>
      <WSPanel>
        <WSFlexBox gap="XL">
          <FieldView
            label="Assignment name"
            value={engagement.engagementName}
          />
          <FieldView
            label="Contractor name"
            value={payeeNames.getResolvedName()}
          />
        </WSFlexBox>
      </WSPanel>

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Assignment cannot be restored when:"
      >
        <WSElement as="ul" ml="L">
          <li>The engagement was archived</li>
        </WSElement>
        To restore assignments related to an engagement, restore the engagement
        first.
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useRestorationNotAllowedModal = () => {
  return useWSModal(RestorationNotAllowedModal, {
    title: "Restore assignment",
    size: "M"
  });
};
